import React, { createContext, useContext, useState, useCallback } from 'react';

// Estado del chat en memoria, por encima del router: sobrevive el cambio de módulo
// pero NO se escribe en disco (mejor para PII) y se limpia al recargar / cerrar sesión.
const AssistantChatContext = createContext(null);

export function AssistantChatProvider({ children }) {
  const [messages, setMessages] = useState([]);
  const [highReasoning, setHighReasoning] = useState(false);

  const reset = useCallback(() => setMessages([]), []);

  return (
    <AssistantChatContext.Provider
      value={{ messages, setMessages, highReasoning, setHighReasoning, reset }}
    >
      {children}
    </AssistantChatContext.Provider>
  );
}

export function useAssistantChat() {
  const ctx = useContext(AssistantChatContext);
  if (!ctx) {
    throw new Error('useAssistantChat debe usarse dentro de AssistantChatProvider');
  }
  return ctx;
}
